// extracted by mini-css-extract-plugin
module.exports = {"root":"_3S15L"};